import React from 'react';
import { Controller, useFormContext, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectCombobox } from '@/shared/ui/Combobox/SelectCombobox.tsx';
import { TaxClassOptions } from '@/clients/tax-classes/useTaxClasses.ts';

type TaxClassFieldValues = { [key: string]: string };

export type TaxClassInputProps = Pick<UseControllerProps<TaxClassFieldValues>, 'name' | 'defaultValue'> & {
    disabled?: boolean;
    onTaxClassChange?: (taxClass?: string) => void;
    testId?: string;
    options: TaxClassOptions[];
    className?: string;
};

export const TaxClassInput = React.forwardRef<HTMLInputElement, TaxClassInputProps>(
    ({ name = 'taxClass', defaultValue, disabled, onTaxClassChange, testId, options, className }, _ref) => {
        const { control } = useFormContext();
        const { t } = useTranslation();

        return (
            <Controller
                name={name}
                defaultValue={defaultValue ?? null}
                control={control}
                render={({ field: { ref, onChange, value }, fieldState }) => (
                    <SelectCombobox
                        fieldRef={ref}
                        value={value ?? undefined}
                        onValueChange={taxClass => {
                            onTaxClassChange?.(taxClass);
                            onChange(taxClass);
                        }}
                        options={options.map(o => ({ value: o.value, label: o.label }))}
                        disabled={disabled}
                        placeholder={t('product.quote.tax')}
                        error={fieldState.error?.message}
                        size="lg"
                        dataTest={testId}
                        className={className}
                    />
                )}
            />
        );
    }
);
